
require('./admin');
require('./bootstrap');
require('./numeric');
require('bootstrap-autocomplete');
require('./commons');
require('./notificaciones');

require('./clientes');
require('./consultas');
require('./ordenes');

require('./admin/bitacora');
require('./admin/micas');
require('./admin/productos');
require('./admin/servicios');
require('./admin/suministros');
require('./admin/opticas');
require('./admin/descuentos');
require('./admin/catalogos');
require('./admin/usuarios');
require('./admin/formatos');

require('./suministros');
require('./domicilios');
require('./documentos');
require('./archivos');

require('tinymce');
require('tinymce/plugins/lists');
require('tinymce/plugins/link');
require('tinymce/plugins/searchreplace');
require('tinymce/plugins/charmap');
require('tinymce/plugins/autolink');
require('tinymce/plugins/code');
require('tinymce/plugins/table');
require('tinymce/plugins/paste');
require('tinymce/plugins/image');
require('tinymce/plugins/wordcount');
require('tinymce/plugins/pagebreak');
require('tinymce/plugins/insertdatetime');
require('tinymce/plugins/visualblocks');
require('tinymce/plugins/advlist');
require('tinymce/icons/default');
